<template>
  <section class="why-choose-us">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header">
        <div class="title-wrapper">
          <!-- Left Decor -->
          <div class="decor left">
            <div class="lines">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
            <div class="dots">
              <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              <span class="dot"></span><span class="dot"></span><span class="dot"></span>
            </div>
          </div>
          
          <h2 class="section-title">为什么选择至讯</h2>
          
          <!-- Right Decor -->
          <div class="decor right">
            <div class="dots">
              <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              <span class="dot"></span><span class="dot"></span><span class="dot"></span>
            </div>
            <div class="lines">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Features Grid -->
      <div class="features-grid">
        <!-- Card 1 -->
        <div class="feature-card">
          <div class="icon-wrapper">
            <img src="../assets/WhyChooseUsSection/1.png" alt="腾讯生态能力" @error="handleImageError" />
          </div>
          <h3 class="card-title">腾讯生态能力</h3>
          <p class="card-desc">依托腾讯生态体系与技术能力，整合多种核心产品与解决方案，提供一站式数字化服务。</p>
        </div>

        <!-- Card 2 -->
        <div class="feature-card">
          <div class="icon-wrapper">
            <img src="../assets/WhyChooseUsSection/2.png" alt="专业交付能力" @error="handleImageError" />
          </div>
          <h3 class="card-title">专业交付能力</h3>
          <p class="card-desc">资深团队，标准化交付流程，精细化项目管理，确保项目高效落地。</p>
        </div>

        <!-- Card 3 -->
        <div class="feature-card">
          <div class="icon-wrapper">
            <img src="../assets/WhyChooseUsSection/3.png" alt="安全与质量保障" @error="handleImageError" />
          </div>
          <h3 class="card-title">安全与质量保障</h3>
          <p class="card-desc">通过 ISO/IEC 27001、ISO 9001 等国际认证，构建完善的安全与质量管理体系。</p>
        </div>

        <!-- Card 4 -->
        <div class="feature-card">
          <div class="icon-wrapper">
            <img src="../assets/WhyChooseUsSection/4.png" alt="多行业服务经验" @error="handleImageError" />
          </div>
          <h3 class="card-title">多行业服务经验</h3>
          <p class="card-desc">服务金融、政务、零售、制造等多行业客户，积累丰富实践经验，助力业务创新。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhyChooseUsSection',
  methods: {
    handleImageError(e) {
      e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" fill="%23f4f8ff"><rect width="120" height="120" rx="20"/></svg>';
    }
  }
}
</script>

<style scoped>
.why-choose-us {
  padding: 80px 0 100px;
  background-color: #f7f9fc;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

/* Header Styles */
.section-header {
  text-align: center;
  margin-bottom: 70px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.section-title {
  font-size: 36px;
  color: #111;
  font-weight: 800;
  letter-spacing: 2px;
}

.decor {
  display: flex;
  align-items: center;
  gap: 16px;
}

.decor .lines {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.decor.left .lines {
  align-items: flex-end;
}

.decor.right .lines {
  align-items: flex-start;
}

.decor .line {
  height: 2px;
  border-radius: 2px;
}

/* 渐变线样式设置 */
.decor .line:nth-child(1) { width: 30px; }
.decor .line:nth-child(2) { width: 60px; }
.decor .line:nth-child(3) { width: 40px; }

.decor.left .line {
  background: linear-gradient(to left, rgba(0, 82, 217, 0.5), transparent);
}

.decor.right .line {
  background: linear-gradient(to right, rgba(0, 82, 217, 0.5), transparent);
}

.decor .dots {
  display: grid;
  grid-template-columns: repeat(3, 4px);
  gap: 4px;
}

.decor .dot {
  width: 4px;
  height: 4px;
  background-color: #0052d9;
  border-radius: 50%;
  opacity: 0.8;
}

/* Grid Styles */
.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* Card Styles */
.feature-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 50px 30px 40px;
  text-align: center;
  border: 1px solid #f0f4f8;
  box-shadow: 0 10px 30px rgba(0, 82, 217, 0.03);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 40px rgba(0, 82, 217, 0.08);
  border-color: transparent;
}

.icon-wrapper {
  width: 130px;
  height: 130px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.feature-card:hover .icon-wrapper img {
  transform: scale(1.08);
}

.card-title {
  font-size: 20px;
  color: #111;
  font-weight: 700;
  margin-bottom: 16px;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 40px;
  }
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>